
































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as $ from 'jquery';
// import DataTableNet from 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';
import '../../public/uikitjs/DataTablesExtJS';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import AudienceSearchToggle from '@/components/AudienceSearchToggle.vue';
import { AudienceDetails } from '../models/AudienceDetails';
import { Action, Getter } from 'vuex-class';
const namespace: string = 'counter';
import PropertySelector from '@/components/PropertySelector.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import BaseView from '../BaseView';
import Common from '../helper/Common';
import { systemTimezone } from '../constants/general';

interface CustomerSearchOption {
    Channel: string;
    Status: string;
}

interface SearchPanelItem {
    field: {
        name: string,
        value: string,
        inputType: string
    };
    operator: string;
    operatorList: object[];
    value: string;
    sourceSelected: Array<{ text: string }>;
    sourceList: Array<{ text: string }>;
    propertiesSelected: any[];
    propertyList: object[];
}

interface SearchOperators {
    name: string;
    value: string;
    excludeFor: string[];
}

interface SearchListOptions {
    name: string;
    value: string;
    inputType: string;
}

const searchOperatorList: SearchOperators[] = [
    { name: 'Equals', value: 'equals', excludeFor: ['propertycode'] },
    { name: 'Contains', value: 'contains', excludeFor: [] },
    { name: 'Begins With', value: 'startwith', excludeFor: ['propertycode'] },
    { name: 'Ends With', value: 'endwith', excludeFor: ['propertycode'] }
];

const searchingInitial: SearchPanelItem = {
    field: {
        name: 'First Name',
        value: 'firstname',
        inputType: 'text'
    },
    operator: 'equals',
    operatorList: searchOperatorList,
    value: '',
    sourceSelected: [],
    sourceList: [],
    propertiesSelected: [],
    propertyList: []
};

const searchListOptions: SearchListOptions[] = [
    { name: 'First Name', value: 'firstname', inputType: 'text' },
    { name: 'Last Name', value: 'lastname', inputType: 'text' },
    { name: 'Email Address', value: 'email', inputType: 'text' },
    { name: 'Reservation Status', value: 'reservationStatus', inputType: 'text' },
    { name: 'Reservation #', value: 'reservation', inputType: 'text' },
    { name: 'Zip', value: 'zipCode', inputType: 'text' },
    { name: 'Property Name', value: 'propertycode', inputType: 'properties' },
    { name: 'Source', value: 'source', inputType: 'text' }
];

const searchOptionInitial: CustomerSearchOption = {
    Channel: 'email',
    Status: '-1'
};

const searchStatusOptions: Array<{ text: string, code: string }> = [
    { text: 'Valid', code: '1' },
    { text: 'Invalid', code: '4' },
    { text: 'Null', code: '2' },
    { text: 'Unsubscribed', code: '5' },
    { text: 'Bounced', code: '6' },
    { text: 'Non-Consent', code: '8' },
    { text: 'Flagged', code: '7' }
];

@Component({
    components: {
        AudienceSearchToggle,
        PropertySelector,
        VueTagsInput
    },
})
export default class AudienceCustomerDetails extends BaseView {
    @Prop({ default: '' })
    public detailType!: string;
    @Prop({ default: null })
    public audienceLastSavedDetails!: AudienceDetails;
    @Prop({ default: null })
    public audienceLastPublishedDetails!: AudienceDetails;
    @Prop({ default: 0 })
    public audienceId!: number;
    @Getter('currentClientId', { namespace })
    private clientId!: number;

    @Getter('currentIsSelectable', { namespace })
    private isAudienceSelectable!: boolean;

    

    private disabledToggle: boolean = false;
    private disableOperator: boolean = false;

    private status: string = '';
    private statusSelected: Array<{ text: string, code: string }> = [];

    private selectedAudienceDetails: AudienceDetails = this.audienceLastSavedDetails;
    private audienceCustomerDetailsTable: any;
    private detailId: number = 0;
    private isSearchDirty: boolean = false;
    private isSearchDirtyPlaceHolder: string = '';
    private toggleSelectionToolTip: string = 'Select All';
    private customerDetailsSearchFilters: AudienceSearchFilter[] = [];
    private searchOption: CustomerSearchOption = JSON.parse(JSON.stringify(searchOptionInitial));

    private searchFieldList: SearchListOptions[] = searchListOptions;
    private currentSearchOperatorList: SearchOperators[] = searchOperatorList;

    private searching: SearchPanelItem = JSON.parse(JSON.stringify(searchingInitial));
    private sourceList: any[] = [];
    private propertyList: any[] = [];

    private statusPlaceholder: string = 'All';
    private statusCSV: string = '';

    private initialSearchToggleFilter: AudienceSearchFilter = new AudienceSearchFilter(
        'audienceDetailType',
        'equals',
        'LastPublished');

    public InitAudienceSearchTable(): void {
        if ($.fn.DataTable.isDataTable('#tableAudienceCustomerDetails')) {
            return;
        }
        this.customerDetailsSearchFilters = this.getSearch();

        const thisDataTable = this;

        this.audienceCustomerDetailsTable = $('#tableAudienceCustomerDetails')
            .on('processing.dt', (e, settings, processing) => {
                // Hack to give some time for the table to render and take the
                // whole width of the container
                setTimeout(() => {
                    processing ?
                        Common.blockElement('tableAudienceCustomerDetails') :
                        Common.unblockElement('tableAudienceCustomerDetails');
                }, 50);
            })
            .DataTable({
                dom: "<'row'<'col-md-6 col-sm-6'><'col-md-6 col-sm-6'f>r><'table-scrollable't><'row'<'col-md-6'l><'col-md-6'p>><'row'<'col-md-12'i>>",
                orderMulti: false, // restrict sort to only one column
                serverSide: true,
                searching: false, // disable filter
                // processing: true,
                columns: [
                    { name: 'customerId', data: { _: 'customerId' } },
                    { name: 'firstname', data: { _: 'firstname' } },
                    { name: 'lastname', data: { _: 'lastname' } },
                    { name: 'email', data: { _: 'email' } },
                    { name: 'emailStatus', data: { _: 'emailStatus' } },
                    { name: 'reservation', data: { _: 'reservation' } },
                    { name: 'reservationStatus', data: { _: 'reservationStatus' } },
                    { name: 'zipCode', data: { _: 'zipCode' } },
                    { name: 'property', data: { _: 'property' } },
                    { name: 'source', data: { _: 'source' } }
                ],
                ajax: {
                    url: this.getDataTableURL(),
                    type: 'POST',
                    data(data, setting) {                            
                        thisDataTable.customerDetailsSearchFilters.forEach((filter) => {
                            if ((typeof filter.Value) === 'string') {
                                filter.Value = filter.Value.replace(/&/g, '%26');
                            }
                        });

                        const Filters = thisDataTable.customerDetailsSearchFilters;
                        data.AppendFilter = {
                            Type: 'CustomerDetailsSearch',
                            AudienceSearch: Filters
                        };                            
                    },
                    error(xhr) {
                        console.log('Error Loading data', xhr);
                    }
                },
                lengthMenu: [[10, 20, 50, 100, 500], [10, 20, 50, 100, 500]],
                language: {
                    lengthMenu: ' _MENU_ entries ',
                    sSearch: 'Filter',
                    infoFiltered: '',
                    // processing: 'Loading...',
                    info: `Showing _START_ to _END_ of _TOTAL_ entries  <br/><medium class='text-muted'>Results displayed are limited by your property access.</medium>`,
                },
                order: [[2, 'asc']],
                columnDefs: [
                    { targets: 'no-sort', orderable: false },
                    { targets: 'no-show', visible: false },
                    {
                        targets: 4, data: 'emailStatus',
                        render(data, type, row, meta) {
                            const className = data == null ? '' : data.replace(/\s+/g, '');
                            return `<span ><span class="icon-dot ${className}"></span>${data}</span>`;
                        }
                    },
                ],
                initComplete() {
                    $('select[name="tableAudienceCustomerDetails_length"]').removeClass('custom-select');
                }
            });            
    }       

    public exportTable() {
        const thisDataTable = this;            
        var url = `/api/CustomerDetailExport/audience/api/v1.0/audiencecriteria/companyid/${thisDataTable.clientId}/audience/detail/${thisDataTable.selectedAudienceDetails.AudienceDetailsID}/customerexport?`;
        var search = this.searchToQueryString();
        if (search !== "") {
            url += search + "&";
        }            
        url += `api_user=${window.eInsightUserEmail}`;

        window.App.$axios.get(url)
            .then((response) => {
                console.log(response);
                if (response.status == 200) {
                    this.successToastPopup('Your report is being generated and will be sent to your email', 'Customer Detail Export');
                } else {
                    this.warningToastPopup('Export failed.', 'Customer Detail Export');
                }
            });
    }
    private searchToQueryString(): string {
        var s = this.getSearch();
        var result = "";
        s.forEach((item) => {
            console.log("item:", item);
            result += "&" + item.Field + "." + this.getOperator(item.Operator) + "='" + item.Value + "'";
            switch (item.Field) {

                default:
            }
        });
        return result;
    }
    private getOperator(operator: string): string {
        
        switch (operator) {
            case "greaterthan":
                return "gte";
            case "lessthan":
                return "lte";
            case "startwith":
                return "stw";
            case "endwith":
                return "edw";
            case "contains":
                return "cts";
            case "equals":
            default:
                return "eq";
        }
    }
    
    public setToggle(areTheSame: boolean, hasLastPublished: boolean) {
        if (areTheSame || !hasLastPublished) {
            this.initialSearchToggleFilter.Value = (areTheSame) ? 'LastPublished' : 'LastSaved';
            this.disabledToggle = true;
            const toggle: any = this.$refs.searchToggleRef;
            toggle.update();
        } else {
            this.disabledToggle = false;
        }
    }

    private filteredProperties() {
        return searchStatusOptions;
    }

    private handleStatusChanged(newStatus: Array<{ text: string, code: string }>) {
        this.statusPlaceholder = newStatus.length === 0 ? 'All' : '';
        this.statusSelected = newStatus;
        this.statusCSV = this.getStatusToCSV(newStatus);
    }

    private getStatusToCSV(props: Array<{ text: string, code: string }>): string {
        let csv: string = '';
        props.forEach((t) => {
            if (csv.length === 0) {
                csv = `${t.code}`;
            } else {
                csv += `,${t.code}`;
            }
        });
        return csv;
    }

    private search() {
        this.customerDetailsSearchFilters = this.getSearch();
        if ($.fn.DataTable.isDataTable('#tableAudienceCustomerDetails')) {
            this.audienceCustomerDetailsTable.ajax.reload();
        } else {
            this.InitAudienceSearchTable();
        }
    }

    private updateDetailID() {
        if (!this.isAudienceSelectable) {
            const toggle: any = this.$refs.searchToggleRef;
            const version: string = JSON.parse(JSON.stringify(toggle.ToggleFilterResults[0])).Value;
            if (version === 'LastPublished') {
                this.selectedAudienceDetails = this.audienceLastPublishedDetails;
            } else {
                this.selectedAudienceDetails = this.audienceLastSavedDetails;
            }
        } else {
            this.selectedAudienceDetails = this.audienceLastPublishedDetails;
        }

        this.updateDataTableURL();
    }

    private displayState(): string {
        if (this.selectedAudienceDetails.IsGenerating) {
            return 'generating';
        } else if (!this.selectedAudienceDetails.hasCount) {
            return 'nocounts';
        } else {
            return 'counts';
        }
    }

    private getLastRunDate() {
        if (this.selectedAudienceDetails.countsLastRunDate == null) {
            return '';
        } else {
            //const date: any = new Date(this.selectedAudienceDetails.countsLastRunDate).toLocaleDateString(window.eInsightUserRegion);
            //const time: any = new Date(this.selectedAudienceDetails.countsLastRunDate).toLocaleTimeString(window.eInsightUserRegion);
            const date = Common.formatDate(this.selectedAudienceDetails.countsLastRunDate);
            const time = Common.formatTime(this.selectedAudienceDetails.countsLastRunDate);
            
            const timezone = systemTimezone();
            const generatedOn: string = `Last Run on ${date} at ${time} (${timezone})`;
            return generatedOn;
        }
    }

    private getSearch(): AudienceSearchFilter[] {
        this.updateDetailID();
        const options: AudienceSearchFilter[] = [];
        if (this.statusCSV.length > 0) {
            options.push(new AudienceSearchFilter(
                'status',
                'contains',
                this.statusCSV));
        }
        if (this.searchOption.Channel.length > 0) {
            options.push(new AudienceSearchFilter(
                'channel',
                'equals',
                this.searchOption.Channel));
        }
        if (this.isSearchDirty) {
            options.push(new AudienceSearchFilter(
                this.searching.field.value,
                this.searching.operator,
                this.searching.value));
        }
        return options;
    }

    private resetSearch() {
        this.statusSelected = [];
        this.statusCSV = '';
        this.updateIsDirty(false);
        this.searching = JSON.parse(JSON.stringify(searchingInitial));
        this.searchOption = JSON.parse(JSON.stringify(searchOptionInitial));
        this.search();
        this.getSearchOperators();
        this.disableOperator = false;
    }

    private getSearchOperators() {
        const li: SearchOperators[] = [];
        let firstOperatorFoound = false;
        searchOperatorList.forEach((i) => {
            if (!i.excludeFor.includes(this.searching.field.value)) {
                li.push(i);
                if (firstOperatorFoound === false) {
                    firstOperatorFoound = true;
                    this.searching.operator = i.value;
                }
            }
        });
        this.currentSearchOperatorList = li;
    }

    private updateIsDirty(isDirty: boolean = true): void {
        this.isSearchDirtyPlaceHolder = isDirty ? 'Empty' : '';
        this.isSearchDirty = isDirty;
        this.disableOperator = this.searching.field.value === 'propertycode';
    }

    private changeSearchField() {
        this.updateIsDirty(true);
        this.getSearchOperators();
        this.searching.value = '';
        this.searching.propertiesSelected = [];
        this.searching.sourceSelected = [];
    }

    private mounted() {
        if (!this.isAudienceSelectable) {
            this.initialSearchToggleFilter.Value = this.detailType;
            const toggle: any = this.$refs.searchToggleRef;
            toggle.update();
        } else {
            this.detailType = 'LastPublished';
            this.initialSearchToggleFilter.Value = this.detailType;
        }
    }

    private updateSearchResults(): void {
        this.customerDetailsSearchFilters = this.getSearch();
        if (!this.selectedAudienceDetails.hasCount) {
            return;
        }
        if ($.fn.DataTable.isDataTable('#tableAudienceCustomerDetails')) {
            $('#tableAudienceCustomerDetails td').remove();
            this.audienceCustomerDetailsTable.ajax.reload();
        } else {
            this.InitAudienceSearchTable();
        }
    }

    private getDataTableURL(): string {
        const thisDataTable = this;
        return `/api/CustomerDetail/audience/api/v1.0/audiencecriteria/companyid/${thisDataTable.clientId}/audience/detail/${thisDataTable.selectedAudienceDetails.AudienceDetailsID}/customer?api_user=${window.eInsightUserEmail}`;
    }

    private updateDataTableURL(): void {
        if ($.fn.DataTable.isDataTable('#tableAudienceCustomerDetails')) {
            this.audienceCustomerDetailsTable.ajax.url(this.getDataTableURL());
        }
    }

    private togglePropertySelected() {
        const pSelector: any = this.$refs.propertySelectorRef;
        pSelector.toggleSelection();
        this.toggleSelectionToolTip = pSelector.toggleSelectionToolTip();
    }
}
